import { render } from "./AppleA.vue?vue&type=template&id=4aa6a2cc&scoped=true"
import script from "./AppleA.vue?vue&type=script&lang=js"
export * from "./AppleA.vue?vue&type=script&lang=js"

import "./AppleA.vue?vue&type=style&index=0&id=4aa6a2cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa6a2cc"]])

export default __exports__